<template>
  <div class="log-mana">

    <div class="search-menu">
      <span class="search-info">时间范围：</span>
      <el-date-picker
        v-model="search.time"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd HH:mm:ss"
        format="yyyy-MM-dd HH:mm"
      />
      <span class="search-info m-l-25">状态：</span>
      <el-select
        v-model="search.result"
        placeholder="请选择状态"
      >
        <el-option
          v-for="result in RESULTS"
          :key="result"
          :label="result"
          :value="result"
        />
      </el-select>

      <el-button
        type="primary"
        @click="getTableList(true)"
      >查询</el-button>
    </div>

    <div class="table-container">
      <el-table
        :data="tableList"
        style="width: 100%"
        header-row-class-name="header-row-class-name"
        row-class-name="row-class-name"
      >
        <el-table-column
          prop="sendTime"
          label="时间"
          align="center"
          width="170"
        />
        <el-table-column
          label="发送地址"
          align="center"
          #default="{ row: { sendTarget } }"
          min-width="220"
        >
          <span
            class="ellipsis"
            :title="sendTarget"
          >{{ sendTarget }}</span>
        </el-table-column>
        <el-table-column
          label="发送数据"
          align="center"
          #default="{ row: { sendData } }"
          width="335"
        >
          <el-popover
            placement="left"
            width="370"
            trigger="hover"
          >
            <div style="max-height: 500px; overflow: auto;">
              <tree-view
                v-if="sendData.startsWith('{')"
                :data="JSON.parse(sendData)"
              />
              <template v-else>{{ sendData }}</template>
            </div>
            <div
              slot="reference"
              class="ellipsis"
            >{{ sendData }}</div>
          </el-popover>
        </el-table-column>
        <el-table-column
          prop="result"
          label="状态"
          align="center"
          #default="{ row: { result } }"
        >
          <el-tag :type="result === '成功' ? 'success' : 'error'">{{ result }}</el-tag>
        </el-table-column>
        <el-table-column
          label="返回数据"
          align="center"
          #default="{ row: { responseData } }"
          width="220"
        >
          <el-popover
            placement="left"
            width="300"
            trigger="hover"
          >
            <div style="max-height: 500px; overflow: auto;">
              <tree-view
                v-if="responseData.startsWith('{')"
                :data="JSON.parse(responseData)"
              />
              <template v-else>{{ responseData }}</template>
            </div>
            <div
              slot="reference"
              class="ellipsis"
            >{{ responseData }}</div>
          </el-popover>
        </el-table-column>
      </el-table>

      <el-pagination
        v-if="tableList.length"
        :total="pagination.total"
        :page-size="pagination.pageSize"
        :current-page="pagination.pageIndex"
        background
        class="pagination"
        layout="prev, pager, next"
        @current-change="handlePaginationChange"
      />
    </div>
  </div>
</template>

<script>
const RESULTS = ['成功', '失败']

export default {
  name: 'LogMana',
  data () {
    return {
      path: {
        // 表格数据接口
        tabelList: '/api/upload/to/province/log/list',
      },

      // 搜索数据
      search: {
        // 时间
        time: [],
        // 状态
        result: '',
      },

      // 搜索状态
      RESULTS,

      // 分页信息
      pagination: {
        // 一共多少页
        pageCount: 1,
        // 第几页
        pageIndex: 1,
        // 一页显示多少个
        pageSize: 10,
        // 总个数
        total: 1,
      },

      // 表格数据
      tableList: [],
    }
  },
  mounted () {
    this.getTableList(true)
  },
  methods: {
    /**
     * @description 获取列表数据
     * @param {Boolean} init 是否初始化分页数据
     * @return {Promise} Async Promise
     */
    async getTableList (init = false) {
      const {
        initPagination,
        getTableListReqParams,
        sendGetTableListReq,
        dealGetTableListReqRes,
      } = this

      if (init) initPagination()

      const params = getTableListReqParams()

      if (!params) return

      const res = await sendGetTableListReq(params)

      if (!res) return

      dealGetTableListReqRes(res)
    },
    /**
     * @description 获取列表请求参数
     * @return {Object} 列表请求参数
     */
    getTableListReqParams () {
      const { search, pagination } = this

      const { pageSize, pageIndex } = pagination

      const params = { ...search }

      let [startTime, endTime] = params.time || []

      if (!startTime) startTime = ''
      if (!endTime) endTime = ''

      delete params.time

      params.startTime = startTime
      params.endTime = endTime
      params.pageSize = pageSize
      params.pageIndex = pageIndex

      return params
    },
    /**
     * @description 发送获取列表数据请求
     * @param {Object} 请求参数
     * @return {Promise} Request Promise
     */
    sendGetTableListReq (params) {
      const {
        $http: { get },
        path: { tabelList },
        notification,
      } = this

      return get(tabelList, params)
        .then(res => {
          if (res.code === 'success') {
            return res
          } else {
            notification('异常', res.msg, 'error')

            return false
          }
        })
        .catch(e => {
          notification('异常', '网络异常，请稍候再试', 'error')

          return false
        })
    },
    /**
     * @description 处理获取列表数据请求响应
     * @param {Object} 请求响应数据
     * @return {Undefined} 无返回值
     */
    dealGetTableListReqRes ({ data }) {
      const { updatePagination } = this

      console.warn(data)

      updatePagination(data)

      this.tableList = data.list
    },
    /**
     * @description 更新分页数据
     * @param {Object} 请求响应数据
     * @return {Undefined} 无返回值
     */
    updatePagination ({ pageCount, pageIndex, total }) {
      const { pagination } = this

      pagination.pageCount = pageCount
      pagination.pageIndex = pageIndex
      pagination.total = total
    },
    /**
     * @description 初始化分页数据
     * @return {Undefined} 无返回值
     */
    initPagination () {
      const { pagination } = this

      pagination.pageCount = 1
      pagination.pageIndex = 1
      pagination.pageSize = 10
      pagination.total = 1
    },
    /**
     * @description 处理分页数据变化
     * @return {Undefined} 无返回值
     */
    handlePaginationChange (pageIndex) {
      const { pagination, getTableList } = this

      pagination.pageIndex = pageIndex

      getTableList()
    },
    /**
     * @description 消息弹窗
     * @param {String} title   弹窗标题
     * @param {String} message 弹窗内容
     * @param {String} type    弹窗类型
     * @return {Undefined} 无返回值
     */
    notification (title = '失败', message = '数据异常,请稍后再试', type = 'error') {
      this.$notify({
        title,
        message,
        type,
        duration: 2000,
      })
    },
  },
}
</script>

<style lang="less" scoped>
.log-mana {
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;

  .search-menu {
    height: 66px;
    background-color: #fff;
    display: flex;
    align-items: center;
    padding-left: 20px;

    .search-info {
      font-size: 14px;
      color: #666;
      margin-left: 10px;
    }

    .el-input {
      width: 150px;
      margin-left: 10px;
    }

    .el-button {
      width: 100px;
      margin-left: 20px;
    }

    .m-l-25 {
      margin-left: 25px;
    }
  }

  .table-container {
    /deep/ .header-row-class-name {
      color: #333;
      font-size: 14px;
      font-weight: bold;
      overflow: hidden;

      th {
        line-height: 25px;
        background-color: #e9f0fa;
      }
    }

    /deep/ .row-class-name {
      color: #333;
      font-size: 14px;
      height: 51px;

      td {
        padding: 9px 0;
      }

      .cell {
        padding: 0 5px;
      }
    }

    .pagination {
      background-color: #fff;
      margin-bottom: 20px;
      padding: 31px 0;
      height: 32px;
      text-align: center;

      /deep/ .number {
        background-color: #fff;
        border: 1px solid #ccc;
        padding: 2px 5px;
        height: 32px;
        min-width: 32px;
      }

      /deep/ .active {
        border: none;
        background-color: #4078dd;
      }

      /deep/ .btn-prev {
        width: 32px;
        height: 32px;
      }

      /deep/ .btn-next {
        width: 32px;
        height: 32px;
      }

      /deep/ .more {
        width: 32px;
        height: 32px;
        line-height: 35px;
      }
    }
  }

  .ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
